import { Component, h, ComponentInterface, Prop } from '@stencil/core';

@Component({
	tag: 'kdx-breadcrumbs',
	styleUrl: 'kdx-breadcrumbs.scss',
	shadow: false
})

export class StBreadcrumbs implements ComponentInterface {
	@Prop() classes: string;

	render() {
		return (
			<div class={`container-fluid kdx-breadcrumbs${this.classes ? ` ${this.classes}` : ''}`}>
				<div class="row">
					<div class="col-12">
						<slot />
					</div>
				</div>
			</div>
		);
	}
}